{
  "backButton": "Nazaj na {prevMenuButton}",
  "moreActions": "Več možnosti",
  "unavailable": "Ni na voljo, razširite za podrobnosti"
}
